import * as R from 'ramda';

export function pickRenderedFields(values, fields) {
  const renderedFieldIds = Object.values(fields).map((field) => field.name);

  return R.pickAll(['id', ...renderedFieldIds], values);
}
